import fastDeepEqual from 'fast-deep-equal';

export function diffItems<K>(prev: K[], next: K[], keyFn: (item: K) => string) {
  const prevMap = new Map();
  const nextSet = new Set();

  // Trying to use good old loops to avoid transpiling
  for (let i = 0; i < prev.length; i++) {
    const re = prev[i];
    prevMap.set(keyFn(re), re);
  }
  const added: K[] = [];
  const removed: K[] = [];
  const updated: K[] = [];
  for (let i = 0; i < next.length; i++) {
    const re = next[i];
    const reKey = keyFn(re);
    if (!prevMap.has(reKey)) {
      added.push(re);
    } else {
      const prevRe = prevMap.get(reKey);
      if (!fastDeepEqual(prevRe, re)) {
        updated.push(re);
      }
    }
    nextSet.add(reKey);
  }
  for (let i = 0; i < prev.length; i++) {
    const re = prev[i];
    if (!nextSet.has(keyFn(re))) {
      removed.push(re);
    }
  }
  return { added, removed, updated };
}
